// src/components/FilterPanel.js
import React, { useState } from "react";

export default function FilterPanel({ show, onClose, filters, setFilters }) {
  const handleChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const clearFilter = () => {
    let filters = {
      genderFilter: "",
      idFilter: "",
      nameFilter: "",
      ageFilter: { minValue: 0, maxValue: 100 },
      jobFilter: "",
      nakshatramFilter: "",
      placeFilter: "",
      salaryFilter: "",
      // salaryFilter: {minSalaryValue: 0, maxSalaryValue:100},
    };
    setFilters(filters);
  };

  const [minValue, setMinValue] = useState(20);
  const [maxValue, setMaxValue] = useState(80);

  // const [minSalaryValue, setMinSalaryValue] = useState(0);
  // const [maxSalaryValue, setMaxSalaryValue] = useState(100);

  const handleMinChange = (e) => {
    const value = Math.min(Number(e.target.value), maxValue - 1);
    setMinValue(value);
    setFilters({ ...filters, ageFilter: { ...filters.ageFilter, minValue } });
  };

  const handleMaxChange = (e) => {
    const value = Math.max(Number(e.target.value), minValue + 1);
    setMaxValue(value);
    setFilters({ ...filters, ageFilter: { ...filters.ageFilter, maxValue } });
  };

  // const handleMinSalaryChange = (e) => {
  //   const value = Math.min(Number(e.target.value), maxSalaryValue - 1);
  //   setMinSalaryValue(value);
  //   setFilters({ ...filters, salaryFilter: { ...filters.salaryFilter, minSalaryValue } });
  // };

  // const handleMaxSalaryChange = (e) => {
  //   const value = Math.max(Number(e.target.value), minSalaryValue + 1);
  //   setMaxSalaryValue(value);
  //   setFilters({ ...filters, salaryFilter: { ...filters.salaryFilter, maxSalaryValue } });
  // };

  return (
    <>
      <div className={`filter-panel ${show ? "open" : ""}`}>
        <div className="filter-header d-flex justify-content-between align-items-center">
          <h5>Filters</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        <div className="filter-body">
          <select
            className="form-control mb-2"
            value={filters.genderFilter}
            onChange={(e) => handleChange("genderFilter", e.target.value)}
          >
            <option value="">Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>

          <input
            type="text"
            placeholder="Profile ID"
            className="form-control mb-2"
            value={filters.idFilter}
            onChange={(e) => handleChange("idFilter", e.target.value)}
          />
          <input
            type="text"
            placeholder="Name"
            className="form-control mb-2"
            value={filters.nameFilter}
            onChange={(e) => handleChange("nameFilter", e.target.value)}
          />
          <div className="mb-2">
            <p>Choose Age range</p>

            <div className="slider-container">
              <input
                type="range"
                min="0"
                max="100"
                value={minValue}
                onChange={handleMinChange}
                className="thumb thumb-left"
              />
              <input
                type="range"
                min="0"
                max="100"
                value={maxValue}
                onChange={handleMaxChange}
                className="thumb thumb-right"
              />
              <div className="slider-track"></div>
              <div
                className="slider-range"
                style={{
                  left: `${minValue}%`,
                  width: `${maxValue - minValue}%`,
                }}
              ></div>
            </div>

            <div style={{ marginTop: "1rem" }}>
              <span>Min: {minValue}</span> &nbsp;|&nbsp;
              <span>Max: {maxValue}</span>
            </div>
          </div>

          <select
            className="form-control mb-2"
            value={filters.jobFilter}
            onChange={(e) => handleChange("jobFilter", e.target.value)}
          >
            <option value="">Job</option>
            <option value="Software">Software</option>
            <option value="Bank">Bank</option>
            <option value="Govt. Job">Govt. Job</option>
            <option value="Private Corporate">Private Corporate</option>
            <option value="Doctor">Doctor</option>
            <option value="Others">Others</option>
          </select>

          <select
            className="form-control mb-2"
            value={filters.nakshatramFilter}
            onChange={(e) => handleChange("nakshatramFilter", e.target.value)}
          >
            <option value="">Nakshatra</option>
            <option value="Ashwini">Ashwini</option>
            <option value="Bharani">Bharani</option>
            <option value="Krittika">Krittika</option>
            <option value="Rohini">Rohini</option>
            <option value="Mrigashira">Mrigashira</option>
            <option value="Ardra">Ardra</option>
            <option value="Punarvasu">Punarvasu</option>
            <option value="Pushya">Pushya</option>
            <option value="Ashlesha">Ashlesha</option>
            <option value="Magha">Magha</option>
            <option value="Purva Phalguni">Purva Phalguni</option>
            <option value="Uttara Phalguni">Uttara Phalguni</option>
            <option value="Hasta">Hasta</option>
            <option value="Chitra">Chitra</option>
            <option value="Swati">Swati</option>
            <option value="Vishakha">Vishakha</option>
            <option value="Anuradha">Anuradha</option>
            <option value="Jyeshtha">Jyeshtha</option>
            <option value="Mula">Mula</option>
            <option value="Purva Ashadha">Purva Ashadha</option>
            <option value="Uttara Ashadha">Uttara Ashadha</option>
            <option value="Shravana">Shravana</option>
            <option value="Dhanishta">Dhanishta</option>
            <option value="Shatabhisha">Shatabhisha</option>
            <option value="Purva Bhadrapada">Purva Bhadrapada</option>
            <option value="Uttara Bhadrapada">Uttara Bhadrapada</option>
            <option value="Revati">Revati</option>
          </select>

          <input
            type="text"
            placeholder="Working Place"
            className="form-control mb-2"
            value={filters.placeFilter}
            onChange={(e) => handleChange("placeFilter", e.target.value)}
          />

          <input
            type="number"
            placeholder="Min Salary in Lakhs"
            className="form-control mb-2"
            value={filters.salaryFilter}
            step={0.01}
            max={100}
            onChange={(e) => handleChange("salaryFilter", e.target.value)}
          />

          {/* <div>
            <p>Choose Salary range</p>

            <div className="slider-container">
              <input
                type="range"
                min="0"
                max="100"
                value={minSalaryValue}
                onChange={handleMinSalaryChange}
                className="thumb thumb-left"
              />
              <input
                type="range"
                min="0"
                max="100"
                value={maxSalaryValue}
                onChange={handleMaxSalaryChange}
                className="thumb thumb-right"
              />
              <div className="slider-track"></div>
              <div
                className="slider-range"
                style={{
                  left: `${minSalaryValue}%`,
                  width: `${maxSalaryValue - minSalaryValue}%`,
                }}
              ></div>
            </div>

            <div style={{ marginTop: "1rem" }}>
              <span>Min: {minSalaryValue}</span> &nbsp;|&nbsp;
              <span>Max: {maxSalaryValue}</span>
            </div>
          </div> */}
        </div>

        <div className="d-flex">
          <button
            className="btn btn-default border border-2 w-100 mt-3 mx-2"
            onClick={() => clearFilter()}
          >
            Clear Filters
          </button>
          <button className="btn btn-primary w-100 mt-3" onClick={onClose}>
            Apply Filters
          </button>
        </div>
      </div>

      {/* Background overlay */}
      {show && <div className="overlay" onClick={onClose}></div>}
    </>
  );
}
